<template>
  <b-tr>
    <slot :isEditing="editing.isEditing" :value="editing.value" :edit="edit" :accept="accept" :cancel="cancel"/>
  </b-tr>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  props: ['value'],
  data() {
    return {
      editing: {
        value: cloneDeep(this.value),
        isEditing: false,
      },
    };
  },
  provide() {
    return {
      original: this.value,
      editing: this.editing,
    };
  },
  watch: {
    value(value) {
      this.editing.value = cloneDeep(value);
    },
  },
  methods: {
    accept() {
      this.editing.isEditing = false;
      this.$emit("input", this.editing.value);
    },
    edit() {
      this.editing.isEditing = true;
    },
    cancel() {
      this.editing.isEditing = false;
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/os/accountability/Editing.vue